import styled from 'styled-components';
import PlayLinkContainer from './PlayLinkContainer';
import { regularWhite } from '../../ui-components/design-tokens';
import { regularOutline } from '../../ui-components/typography/helpers';

export const StyledPlayLinkExternal = styled(PlayLinkContainer)`
    color: ${regularWhite};
    text-decoration: none;

    &:focus {
        ${regularOutline()};
    }
`;

export const StyledLinkTarget = styled.span`
    text-decoration: underline;
`;
